// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__ifv5y","rotation":"spinner_rotation__x5aCX"};